import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Filter(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="12,2.5 7,2.5 5,2.5 0,2.5 5,9.717 5,15.5 7,13.5 7,9.717" />
        </SvgIcon>
    );
}

Filter.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Filter;
